import { useAppState } from "../context/AppStateContext";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";

import ResponsiveAppBar from "../components/layout/ResponsiveAppBar";
import InputHeader from "../components/proposal/proposalInput/InputHeader";
import ProposalInfoForm from "../components/proposal/proposalInput/ProposalInfoForm";
import CompanyInfoForm from "../components/proposal/proposalInput/CompanyInfoForm";
import CustomerInfoForm from "../components/proposal/proposalInput/CustomerInfoForm";
import BDMInfoForm from "../components/proposal/proposalInput/BDMInfoForm";
import OpportunityInfoForm from "../components/proposal/proposalInput/OpportunityInfoForm";
import DocumentUploadForm from "../components/proposal/proposalInput/DocumentsUploadForm";
import InputFooter from "../components/proposal/proposalInput/InputFooter";
import Loader from "../components/layout/Loader";
import ErrorModal from "../components/layout/ErrorModal";

const ProposalInputPage = () => {
  const { apiRes, setApiRes } = useAppState();

  return (
    <Box className="mainContainer">
      {apiRes.loading && <Loader showMsg={true} />}

      <ResponsiveAppBar />
      <Container maxWidth="xl">
        <Grid
          container
          spacing={2}
          sx={{ my: 3 }}
        >
          <InputHeader />
          <ProposalInfoForm />
          <CompanyInfoForm />
          <CustomerInfoForm />
          <BDMInfoForm />
          <OpportunityInfoForm />
          <DocumentUploadForm />
          <InputFooter />
        </Grid>
      </Container>
      <ErrorModal apiRes={apiRes} setApiRes={setApiRes} />
    </Box>
  );
};

export default ProposalInputPage;